import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  IconButton,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";

import {
  getExpenseItems,
  createExpenseItem,
  deleteExpenseItem,
  updateExpenseItem,
} from "../../../../api/Expenses/expenseItemsApi";

import ExpenseItemAttachmentsDrawer from "./ExpenseItemAttachmentsDrawer";

const ExpenseItemsTab = ({ documentId, isLocked, onRefreshSummary }) => {
  const [items, setItems] = useState([]);
  const [openItem, setOpenItem] = useState(null);

  const loadItems = async () => {
    const data = await getExpenseItems(documentId);
    setItems(data);
  };

  useEffect(() => {
    loadItems();
  }, [documentId]);

  // ➕ Crear gasto
  const handleAdd = async () => {
    if (isLocked) return;

    await createExpenseItem({
      ExpenseDocumentId: documentId,
      ExpenseDate: new Date(),
      Concept: "Nuevo gasto",
      ExpenseType: "other",
      Amount: 0,
      Currency: "EUR",
      ExchangeRate: 1,
      AmountEUR: 0,
    });

    await loadItems();
    onRefreshSummary?.();
  };

  // 🗑 Eliminar gasto
  const handleDelete = async (id) => {
    if (isLocked) return;

    await deleteExpenseItem(id);
    await loadItems();
    onRefreshSummary?.();
  };

  // ✏️ Actualizar gasto
  const handleUpdate = async (id, data) => {
    if (isLocked) return;

    await updateExpenseItem(id, data);
    await loadItems();
    onRefreshSummary?.();
  };

  return (
    <Box>
      {/* 🔒 Aviso */}
      {isLocked && (
        <Alert severity="info" sx={{ mb: 2 }}>
          El documento está bloqueado y no se puede editar.
        </Alert>
      )}

      {/* ➕ Añadir */}
      <Button
        variant="contained"
        onClick={handleAdd}
        sx={{ mb: 2 }}
        disabled={isLocked}
      >
        Añadir gasto
      </Button>

      {items.map((item) => (
        <Paper key={item.id} sx={{ p: 2, mb: 1 }}>
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            {/* 📅 Fecha */}
            <TextField
              type="date"
              size="small"
              defaultValue={dayjs(item.ExpenseDate).format("YYYY-MM-DD")}
              disabled={isLocked}
              onBlur={(e) =>
                handleUpdate(item.id, {
                  ExpenseDate: e.target.value,
                })
              }
            />

            {/* 📝 Concepto */}
            <TextField
              size="small"
              label="Concepto"
              defaultValue={item.Concept}
              disabled={isLocked}
              onBlur={(e) =>
                handleUpdate(item.id, {
                  Concept: e.target.value,
                })
              }
              sx={{ flex: 1 }}
            />
            {/* 💳 Forma de pago */}
            <FormControl size="small" sx={{ minWidth: 180, width: 180 }}>
              <InputLabel>Forma de pago</InputLabel>
              <Select
                label="Forma de pago"
                value={item.PaymentType || "personal_card"}
                disabled={isLocked}
                onChange={(e) =>
                  handleUpdate(item.id, {
                    PaymentType: e.target.value,
                  })
                }
              >
                <MenuItem value="cash">💵 Efectivo</MenuItem>
                <MenuItem value="company_card">💳 Tarjeta empresa</MenuItem>
                {/* <MenuItem value="personal_card">💳 Tarjeta personal</MenuItem> */}
              </Select>
            </FormControl>

            {/* 💶 Importe */}
            <TextField
              size="small"
              type="number"
              label="€"
              defaultValue={item.AmountEUR}
              disabled={isLocked}
              onBlur={(e) => {
                const value = Number(e.target.value || 0);
                handleUpdate(item.id, {
                  Amount: value,
                  AmountEUR: value,
                });
              }}
              inputProps={{
                style: { textAlign: "right" },
              }}
              sx={{ width: 120 }}
            />

            {/* 🗑 Eliminar */}
            <IconButton
              color="error"
              onClick={() => handleDelete(item.id)}
              disabled={isLocked}
            >
              <DeleteIcon />
            </IconButton>

            {/* 📎 Adjuntos */}
            <IconButton onClick={() => setOpenItem(item)} title="Adjuntos">
              📎
            </IconButton>
          </Box>
        </Paper>
      ))}

      {openItem && (
        <ExpenseItemAttachmentsDrawer
          item={openItem}
          /*  status={status} */
          onClose={() => setOpenItem(null)}
        />
      )}
    </Box>
  );
};

export default ExpenseItemsTab;
